<script lang="ts">
    export let src: string, alt: string

    let shouldZoom = false,
        imagePosition: HTMLButtonElement,
        zoomFactor = 3, // Beispiel-Zoomfaktor, anpassen für stärkeren oder schwächeren Zoom
        initialClickPosition = { x: 0, y: 0 },
        currentPosition = { x: 0, y: 0 },
        coordX = 0,
        coordY = 0
    function handleMousemove(event: MouseEvent) {
        if (!shouldZoom) return
        var rect = imagePosition.getBoundingClientRect()
        currentPosition.x = event.clientX - rect.left
        currentPosition.y = event.clientY - rect.top
        coordX = currentPosition.x * -1 * zoomFactor
        coordY = currentPosition.y * -1 * zoomFactor
    }

    function handleClick(event: MouseEvent) {
        shouldZoom = !shouldZoom
        if (shouldZoom) {
            handleMousemove(event)
        } else {
            // Zurücksetzen, wenn bereits gezoomt wurde
            initialClickPosition.x = 0
            initialClickPosition.y = 0
        }
    }
</script>

<div class="imageholder">
    <button
        class="image"
        class:allowZoom="{shouldZoom}"
        on:click="{handleClick}"
        on:mousemove="{handleMousemove}"
        bind:this="{imagePosition}"
    >
        <img
            src="{src}"
            alt="{alt}"
        />
        <div class="zoomimg">
            <img
                src="{src}"
                alt="{alt}"
                style="left: {coordX}px; top: {coordY}px;"
            />
        </div>
    </button>
</div>

<style lang="less">
    @import "../../../assets/css/variables.less";
    .imageholder {
        height: 100%;
        width: fit-content;
        flex-shrink: 0;
        .image {
            background: var(--bg-300);
            height: 100%;
            position: relative;
            overflow: hidden;

            img {
                height: 100%;
                width: auto;
                object-fit: contain;
            }
            .zoomimg {
                opacity: 0;
                visibility: hidden;
                background: var(--bg-300);
                position: absolute;
                top: 0;
                left: 0px;
                bottom: 0;
                right: 0px;
                img {
                    position: absolute;
                    width: 400%;
                    height: auto;
                    top: 0;
                    left: 0;
                    transition: top 0s ease, left 0s ease;
                }
            }
            &:hover {
                cursor: cell;
            }
            &.allowZoom:hover {
                cursor: crosshair;
                > .zoomimg {
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
    }
</style>
